module.exports = __webpack_public_path__ + "img/book-08.00d3a49e.png";